(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {
        /**
         * looks for the search results on the page and sets keywords used to eVar11 and prop11
         * @param trackingObject
         */

        //remove reliance on jQuery
        //if (jQuery("body").hasClass("page-search")) {

        var bodyElement = document.body;

        if (typeof(bodyElement) != "undefined") {

            if (bodyElement.classList.contains("page-search")) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == "query"){
                        analytics.sitecatalyst.prop11 = pair[1];
                        analytics.sitecatalyst.eVar11 = pair[1];
                        console.log("nadex analytics: keywords found", pair[1]);                    
                    }
                }
            }
        }
    });
})(window.nadex.marketing.analytics);